import { useState, useEffect } from 'react'
import BackOfficeAPIClient from '../clients/BackofficeAPIClient'
import { Site } from '../types/Site'
import { SiteOption } from '../types/SiteOption'

const backofficeApiClient = new BackOfficeAPIClient()

export function useSites(): SiteOption[] {
    const [ sites, setSites ] = useState<SiteOption[]>([])

    useEffect(() => {
        backofficeApiClient.get<Site[]>('/sites')
            .then(data => setSites(
                data
                    .map(s => ({ value: s.IDSite, label: String(s.Descr), idPlaque: s.IDPlaque ?? s.IDSite }))
                    .sort((a, b) => a.label.localeCompare(b.label, 'fr'))
            ))
            .catch(console.log)
    }, [])

    return sites
}
